var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketingAd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    fill: "none",
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52 104c28.719 0 52-23.281 52-52S80.719 0 52 0 0 23.281 0 52s23.281 52 52 52z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E3557",
    fillRule: "evenodd",
    d: "M71.932 73.667H32.07c-4.947 0-8.96-4.009-8.96-8.956V39.289c0-4.944 4.013-8.956 8.96-8.956h39.863c4.947 0 8.956 4.012 8.956 8.956V64.71c0 4.947-4.009 8.956-8.956 8.956z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.705 61.1c.344 0 .591-.156.695-.514l.877-2.75h6.983l.877 2.75c.104.358.35.514.695.514h2.607c.448 0 .663-.254.513-.696l-5.785-16.99c-.104-.339-.37-.514-.715-.514h-3.367c-.345 0-.611.175-.715.513l-5.785 16.991c-.15.442.065.696.513.696h2.607zm7.487-6.617h-4.847l2.424-7.605 2.423 7.605zM60.689 61.1c5.018 0 8.775-3.985 8.775-9.1 0-5.116-3.757-9.1-8.775-9.1H53.57c-.396 0-.617.22-.617.617v16.965c0 .397.22.618.617.618h7.118zm0-3.432h-4.16V46.332h4.16c3.159 0 5.33 2.307 5.33 5.668 0 3.36-2.171 5.668-5.33 5.668z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingAd);
export default __webpack_public_path__ + "static/media/marketing-ad.569220b3a09640a9f5ee577d24325357.svg";
export { ForwardRef as ReactComponent };